export const DOMAIN = "https://nanikidsfutsal.com/api/";
export const DOMAIN_MAIN = "https://nanikidsfutsal.com/api";
// export const DOMAIN = "http://localhost:4004/api/";
// export const DOMAIN_MAIN = "http://localhost:4004/api";